import { render } from "./RecuperarContrasena_2.vue?vue&type=template&id=54c2ed6f&scoped=true"
import script from "./RecuperarContrasena_2.vue?vue&type=script&lang=js"
export * from "./RecuperarContrasena_2.vue?vue&type=script&lang=js"

import "./RecuperarContrasena_2.vue?vue&type=style&index=0&id=54c2ed6f&lang=scss&scoped=true"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c2ed6f"]])

export default __exports__